import { alertRequest, body, request } from "services/request";

const resource = "api/adminPanel";

const getOrganizationDemoPeriod = (id: number) =>
    request(`${resource}/getOrganizationDemoPeriod/${id}`, { method: "GET" });

const editOrganizationDemoPeriod = (params: {}) => alertRequest(`${resource}/editOrganizationDemoPeriod`, body(params));

export { getOrganizationDemoPeriod, editOrganizationDemoPeriod };
